import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImages1Alt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"images-1-alt, photos, pictures, shot"} maskId="square-filled-radius-0-stroke-1-IconImages1Alt"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM4 16V20H16L8 12L4 16ZM15 7C13.8954 7 13 7.89543 13 9C13 10.1046 13.8954 11 15 11C16.1046 11 17 10.1046 17 9C17 7.89543 16.1046 7 15 7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImages1Alt;
